type CreditsCellProps = {
  value: { credits?: number };
};

export default function CreditsCell({ value }: CreditsCellProps) {
  return <span>{value.credits?.toFixed(2)}</span>;
}
